import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import { StyledTalentAnchor, StyledTalentsImageContainer, StyledTalentHeading, StyledTalentText } from './TalentCard.styles.mjs';

const TalentCard = ({ href, imageSrc, name, role }) => (React.createElement(StyledTalentAnchor, { href: href },
    React.createElement(StyledTalentsImageContainer, null,
        React.createElement("img", { width: "100%", height: "100%", src: imageSrc, alt: `${name} picture` })),
    React.createElement(StyledTalentHeading, { tag: "h3" }, name),
    React.createElement(StyledTalentText, { tag: "p", size: Size.Small }, role)));

export { TalentCard as default };
//# sourceMappingURL=TalentCard.mjs.map
